/**
 * @file check-developer.ts
 * @description 개발자 계정 체크 유틸리티 (클라이언트/서버 공통)
 *
 * 프로젝트 전역에서 개발자 계정만 모든 기능을 사용할 수 있도록 하는 공통 유틸리티입니다.
 *
 * 주요 기능:
 * - 개발 모드 플래그(NEXT_PUBLIC_DEV_MODE) 기반 개발자 체크
 *
 * 사용 방법:
 * - 클라이언트: `isDeveloper()` 또는 `useIsDeveloper()` 훅 사용
 * - 서버: `isDeveloper()` 함수 직접 사용
 */

/**
 * 개발자 계정 여부 확인 (클라이언트/서버 공통)
 *
 * 개발 모드 플래그(NEXT_PUBLIC_DEV_MODE)가 설정되어 있으면 개발자로 인식합니다.
 *
 * @returns 개발자 계정 여부
 */
export function isDeveloper(): boolean {
  return process.env.NEXT_PUBLIC_DEV_MODE === "true";
}
